export default __webpack_public_path__ + "static/media/lethe_intro.13693ce6.png";